/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import Header from '../../components/header';
import Footer from '../../components/footer';
import stepImg1 from '../../assets/a3/step1.png';
import stepImg2 from '../../assets/a3/step2.png';
import stepImg3 from '../../assets/a3/step3.png';
import stepImg4 from '../../assets/a3/step4.png';
import stepImg5 from '../../assets/a3/step5.png';
import stepImg6 from '../../assets/a3/step6.png';
import stepImg7 from '../../assets/a3/step7.png';
import stepImg8 from '../../assets/a3/step8.png';
import stepImg9 from '../../assets/a3/step9.png';
import stepImg10 from '../../assets/a3/step10.png';
import stepImg11 from '../../assets/a3/step11.png';
import stepImg12 from '../../assets/a3/step12.png';
import stepImg13 from '../../assets/a3/step13.png';
import stepImg14 from '../../assets/a3/step14.png';
import stepImg15 from '../../assets/a3/step15.png';
import notprogramImg1 from '../../assets/a3/notpragram1.png';
import notprogramImg2 from '../../assets/a3/notpragram2.png';
import iconeWindows from '../../assets/a3/iconeWindows.png';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';

export default function A1() {
  const history = useHistory();

  const [step, setStep] = useState(1);
  const [notprogram, setNotProgram] = useState(0);

  function handleInit(e) {
    e.preventDefault();
    history.push('/options');
  }

  return (
    <>
      <Header content="Tutorial Instalação A3" />
      <div className="tutorial-container container-md">
        <div className="tutorial-content">
          <div className="row">
            <div
              className="tutorial-step"
              style={{ display: step === 1 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6">
                  <img src={stepImg1} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 1. 1  </h1>
                  <h6> Verificar a Instalação e versão do SafeSign .</h6>
                  <p>- Em sua área de trabalho clique com o cursor do seu mouse no ícone <strong>Iniciar</strong> <img src={iconeWindows} alt="" className="iW" /> <br />
                     - Clique em Painel de Controle
                   </p>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: step === 2 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg2} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 1. 2 </h1>
                  <h6> Verificar a Instalação e versão do SafeSign.</h6>
                  <p>
                    - Clique em Programa
                  </p>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: step === 3 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg3} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 1. 3 </h1>
                  <h6> Verificar a Instalação e versão do SafeSign.</h6>
                  <p>
                    - Clique em Programas e Recursos
                  </p>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: step === 4 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg4} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 1. 4 </h1>
                  <h6> Verificar a Instalação e versão do SafeSign.</h6>
                  <p>
                    - Procure pelo programa SafeSign conforme  a imgem ao lado e verifique a se a versão é <strong> 3.0.124 </strong> ou superior . <br />
                    - Escolha uma das opções abaixo para prosseguir
                  </p>
                  <div className="row">
                    <div className="col">Tenho o programa
                      <button
                        type="submit"
                        className="btn btn-info m-1 btn-tutorial"
                        onClick={() => setStep(13)}
                      >
                        Clique aqui
                      </button>
                    </div>
                    <div className="col">Abaixo da versão
                    <button
                        type="submit"
                        className="btn btn-info m-1 btn-tutorial"
                        onClick={() => (setNotProgram(1), setStep(0))}
                      >
                        Clique aqui
                      </button>
                    </div>
                    <div className="col">
                      Não tenho
                    <button
                        type="submit"
                        className="btn btn-info m-1 btn-tutorial"
                        onClick={() => setStep(step + 1)}
                      >
                        Clique aqui
                      </button>
                    </div>
                  </div>

                  <p className="bottom" >- Caso não tenha o programa você também pode clicar em avançar</p>

                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: step === 5 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg5} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 2. 1 </h1>
                  <h6> instalando o  SafeSign.</h6>
                  <p>
                    - Verifique o tipo do sistema operacional, se é 64 Bits ou 34 Bits. Em sua área de trabalho clique com o cursor do seu mouse no ícone <strong>Iniciar</strong> <img src={iconeWindows} alt="" className="iW" /> <br />
                    - Clique em <strong> Computador</strong> <br />
                    - Com o lado direito do botão do mouse clique em <strong> Propriedades</strong>.
                  </p>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: step === 6 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg6} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 2. 2 </h1>
                  <h6> instalando o  SafeSign.</h6>
                  <p>
                    - verifique o tipo do sistema operacional conforme a imagem abaixo se é de 64 Bits ou 34 Bits e baixe clicando no botão abaixo:
                  </p>
                  <div className=" d-flex justify-content-center ">

                    <a href="https://static.gigage.com.br/drivers/safesign/SafeSign_3.0.124/SafeSignIC-Windows_x86/SafeSignIC30124-x86-win-tu-admin.exe" className="btn btn-info m-1 btn-tutorial">32 Bits</a>


                    <a href="https://static.gigage.com.br/drivers/safesign/SafeSign_3.0.124/SafeSignIC-Windows_x64/SafeSignIC30124-x64-win-tu-admin.exe" className="btn btn-info m-1 btn-tutorial">64 Bits</a>

                  </div>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: step === 7 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg7} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 2. 3 </h1>
                  <h6>instalando o  SafeSign.</h6>
                  <p>
                    - Clique 2 vezes no programa que baixou
                  </p>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: step === 8 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg8} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 2. 4 </h1>
                  <h6> instalando o  SafeSign.</h6>
                  <p>
                    - Avance, aceite os termos e sigua o processo clicando em avançar
                  </p>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: step === 9 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg9} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 2. 5 </h1>
                  <h6>instalando o  SafeSign.</h6>
                  <p>
                    - Durante a instalação, o processo será interrompido e aparecerá o ícone que na sua barra de tarefa. <br />
                    - Clique no ícone indicado pela seta.
                  </p>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: step === 10 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg10} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 2. 6 </h1>
                  <h6>instalando o  SafeSign.</h6>
                  <p>
                    - Clique em firefox. <br />
                    - Clique em instalar.
                  </p>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: step === 11 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg11} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 2. 7 </h1>
                  <h6> instalando o  SafeSign.</h6>
                  <p>
                    - Clique ok. <br />
                    - Clique em fechar.
                  </p>
                </div>
              </div>
            </div>


            <div
              className="tutorial-step"
              style={{ display: step === 12 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg12} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 2. 8</h1>
                  <h6> instalando o  SafeSign.</h6>
                  <p>
                    - Espere terminar o processo e clique em finalizar . <br />
                  </p>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: step === 13 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg13} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 3. 1 </h1>
                  <h6> Verificando o certificado .</h6>
                  <p>
                    - Insira seu Token ou cartão na USB do seu computador <br />
                    - Com o cursor do seu mouse clique no ícone <strong> Iniciar</strong> <img src={iconeWindows} alt="" className="iW" /> <br />
                    - Busque por Token <br />
                    - Abra o programa Token Administration. <br />
                  </p>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: step === 14 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg14} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 3. 2 </h1>
                  <h6> Verificando o certificado .</h6>
                  <p>
                    - Clique em IDs Digitais. <br />
                    - Clique em Mostrar IDs Digitais registradas....
                  </p>
                </div>
              </div>
            </div>
            <div
              className="tutorial-step"
              style={{ display: step === 15 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={stepImg15} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 3. 3 </h1>
                  <h6> Verificando o certificado .</h6>
                  <p>
                    - Procure pelo cartão verde, que está as informações do seu certificado. <br />
                    - O certificado está pronto para uso.
                  </p>
                </div>
              </div>
            </div>
            <div
              className="tutorial-step"
              style={{ display: step === 16 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6">
                  <h1 className= "d-flex justify-content-center">Atenção</h1>
                  <p>
                    - Se for digitado o <strong>PIN</strong>  erradamente por três vezes seguidas o dispositivo será bloqueado, neste
                    caso portanto, para desbloqueá-lo só será possível com a senha PUK. <br/>
                    - Apos <strong> três vezes</strong> tentativas erradas da senha PUK, para desbloquear o PIN, ocorrerá o bloqueio
                    definitivo do Certificado Digital. <br/>
                    - Em caso de dúvidas ou de dificuldades não hesite em entrar em contato com o
                    departamento de Suporte, o qual está inteiramente capacitado a lhe fornecer o
                    apoio necessário.
                  </p>
                </div>
                <div className="col-6">
                  <h1>passo 4</h1>
                  <h6>  Dúvidas e contatos .</h6>
                  <p>
                    - Tel: 080 028 22 227. <br />
                    - (22) 2726 – 1400. <br />
                    - Horário de atendimento: segunda a sexta, de 08:00 as 18:00. <br/>
                    - Clicando no botão você também estara entrando em contato conosco!

                  </p>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: notprogram === 1 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={notprogramImg1} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 1. 5</h1>
                  <h6> Desinstalando o  SafeSign.</h6>
                  <p>
                    - Selecione o programa e clique com o botão direito do seu mouse em desinstalar.
                  </p>
                </div>
              </div>
            </div>

            <div
              className="tutorial-step"
              style={{ display: notprogram === 2 ? 'block' : 'none' }}
            >
              <div className="row">
                <div className="col-12" />
              </div>
              <div className="row">
                <div className="col-6 tutorial-img">
                  <img src={notprogramImg2} alt="" />
                </div>
                <div className="col-6">
                  <h1>Passo 1. 6</h1>
                  <h6> Desinstalando o  SafeSign.</h6>
                  <p>
                    - clique em sim e espere o processo terminar. <br />
                - Clique em avançar para fazer a instalação do safesing
              </p>
                </div>
              </div>
            </div>



          </div>
        </div>

        <div className="row " style={{ display: step >= 1 ? 'block' : 'none' }}>
          <div className="col-12">
            <div className="row justify-content-between ml-3 mr-3">
              <div>
                {step >= 2 ? (
                  <button
                    type="submit"
                    className="btn btn-info m-1 btn-tutorial"
                    onClick={() => setStep(step - 1)}
                  >
                    Voltar
                  </button>
                ) : (
                    ''
                  )}
              </div>

              {step >= 1 && step <= 15 ? (
                <button
                  type="submit"
                  className="btn btn-info m-1 btn-tutorial"
                  onClick={() => setStep(step + 1)}
                >
                  Avançar
                </button>
              ) : (
                  ''
                )}

              {step === 16 ? (
                <a href="http://sigremoto.com/" className="btn btn-info m-1 btn-tutorial" target="_blank" >Suporte Técnico</a>
                
              ) : (
                  ''
                )}
            </div>
          </div>
        </div>
        <div className="row " style={{ display: notprogram >= 1 ? 'block' : 'none' }}>
          <div className="col-12">
            <div className="row justify-content-between ml-3 mr-3">
              <div>
                {notprogram >= 2 ? (
                  <button
                    type="submit"
                    className="btn btn-info m-1 btn-tutorial"
                    onClick={() => setNotProgram(notprogram - 1)}
                  >
                    Voltar
                  </button>
                ) : (
                    ''
                  )}
              </div>

              {notprogram == 1 ? (
                <button
                  type="submit"
                  className="btn btn-info m-1 btn-tutorial"
                  onClick={() => setNotProgram(notprogram + 1)}
                >
                  Avançar
                </button>
              ) : (
                  ''
                )}

              {notprogram === 2 ? (
                <button type="submit" className="btn btn-info m-1 btn-tutorial" onClick={() => (setNotProgram(0), setStep(5))}>
                  Avançar
                </button>
              ) : (
                  ''
                )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
